export default __webpack_public_path__ + "static/media/chart-icon.84885290.svg";